import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AdminServiceNew } from '../services/admin-new.service';
import { AuthService } from '@auth0/auth0-angular';
import { map, switchMap } from 'rxjs';
import { HOME_PATH, LOGIN_PATH } from '../../../../apps/values/path';

export const HasNotChangedInitialPasswordGuardAdmin: CanActivateFn = (
  route,
  state
) => {
  const ROUTER = inject(Router);
  const auth0Service = inject(AuthService);
  const adminService = inject(AdminServiceNew);

  return auth0Service.user$.pipe(
    switchMap((user) => {
      if (!user?.sub) {
        ROUTER.navigate([`/${LOGIN_PATH}`]);
        return [false];
      }

      return adminService.getAdminProfile(user.sub).pipe(
        map((adminProfile) => {
          if (
            adminProfile &&
            adminProfile.has_changed_initial_password === true
          ) {
            ROUTER.navigate([`/${HOME_PATH}`]);
            return false;
          }
          return true;
        })
      );
    })
  );
};
